
import Vue from 'vue';
import type { PropOptions } from 'vue';
import { mapGetters } from 'vuex';
import PublicPortfolioWorkHistory from './PublicPortfolioWorkHistory.vue';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import type { PublicPortfolioConfiguration } from '@/types/graphql';
import PublicPortfolioWorkHistoryModal from '~/components/partials/public-portfolio/PublicPortfolioWorkHistory/PublicPortfolioWorkHistoryModal.vue';
import PublicPortfolioAddWorkHistoryModal from '~/components/partials/public-portfolio/PublicPortfolioWorkHistory/PublicPortfolioAddWorkHistoryModal.vue';
import type { Portfolio } from '~/types/portfolio';
import PublicPortfolioEditWorkHistoryModal from '~/components/partials/public-portfolio/PublicPortfolioWorkHistory/PublicPortfolioEditWorkHistoryModal.vue';
import type { SectionMode } from '~/components/partials/public-portfolio/types';

const DEFAULT_VISIBLE_WORKHISTORIES_COUNT = 3;

export default Vue.extend({
  name: 'PublicPortfolioWorkHistorySection',
  components: {
    PublicPortfolioEditWorkHistoryModal,
    PublicPortfolioWorkHistoryModal,
    PublicPortfolioWorkHistory,
    PublicPortfolioAddWorkHistoryModal,
    BravadoButtonV3,
  },
  props: {
    mode: {
      type: String,
      default: 'view',
    } as PropOptions<SectionMode>,
    configuration: {
      type: Object,
      required: true,
    } as PropOptions<PublicPortfolioConfiguration>,
  },
  data() {
    return {
      defaultVisibleWorkHistoriesCount: DEFAULT_VISIBLE_WORKHISTORIES_COUNT,
      areAllWorkHistoriesVisible: false,
    };
  },
  computed: {
    ...mapGetters('portfolio', ['sortedWorkHistories']),
    rootClass(): Record<string, boolean> {
      return {
        'public-portfolio-work-history-section': true,
        'public-portfolio-work-history-section--empty': !this.sortedWorkHistories.length,
      };
    },
    defaultVisibleWorkHistories(): Portfolio.Workhistory[] {
      return this.sortedWorkHistories.slice(0, DEFAULT_VISIBLE_WORKHISTORIES_COUNT);
    },
    showMoreText(): string {
      if (this.areAllWorkHistoriesVisible) {
        return 'Show less';
      } else {
        return `Show all`;
      }
    },
  },
});
